import { createSlice } from "@reduxjs/toolkit";

const localChallenge = localStorage.getItem("uvita-challenge");
export const challengeSlice = createSlice({
    name: "challenge",
    initialState: {
        challengeData: (localChallenge && JSON.parse(localChallenge)) || {},
    },
    reducers: {
        setChallengeData: (state, action) => {
            state.challengeData = action.payload;
            localStorage.setItem(
                "uvita-challenge",
                JSON.stringify(action.payload) || ""
            );
        },
    },
});
// 每个 case reducer 函数会生成对应的 Action creators
export const { setChallengeData } = challengeSlice.actions;

// 导出默认的reducer
export default challengeSlice.reducer;
